import { UICampaignItem } from '@mm/state/reducers/campaignsOverview';
import classNames from 'classnames';
import React from 'react';
import { Grid } from '../../../../../../common/components/Grid/Grid';
import { UIFilterCampaignKindType } from '../types';
import { AutomationRow } from './EntityRows/AutomationRow/AutomationRow';
import { CampaignRow } from './EntityRows/CampaignRow';
import { CtmAdRow } from './EntityRows/CtmAdRow';
import { LegacyMessengerAdRow } from './EntityRows/LegacyMessengerAdRow';
import { RssBlastRow } from './EntityRows/RssBlastRow';
import { SponsoredMessageRow } from './EntityRows/SponsoredMessageRow';

type Props = {
  className?: string;
  campaigns: UICampaignItem[];
  fetchCurrentActiveKind: (page?: number) => void;
};

export type RowComponent = (props: {
  item: UICampaignItem;
  kind?: UIFilterCampaignKindType;
  fetchCurrentActiveKind?: (page?: number) => void;
}) => JSX.Element | null;

const campaignKindRowTypeMap: Partial<
  Record<UIFilterCampaignKindType, RowComponent>
> = {
  chat_blaster: CampaignRow,
  drip_campaigns: CampaignRow,
  ctm_ads: CtmAdRow,
  legacy_messenger_ads: LegacyMessengerAdRow,
  sponsored_messages: SponsoredMessageRow,
  rss_blasts: RssBlastRow,
  automation: AutomationRow,
};

export const CampaignsTable = ({
  campaigns,
  className,
  fetchCurrentActiveKind,
}: Props) => {
  return (
    <Grid className={classNames(className, 'campaigns__table')}>
      {campaigns.map((campaign: UICampaignItem) => {
        const kind = campaign.filterKind;
        const Component = campaignKindRowTypeMap[kind];
        if (!Component) return;
        return (
          <Component
            key={campaign.id}
            item={campaign}
            kind={kind}
            fetchCurrentActiveKind={fetchCurrentActiveKind}
          />
        );
      })}
    </Grid>
  );
};
